/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
/**
 * An enumeration.
 */
export var CadenceMonitoringMetricType;
(function (CadenceMonitoringMetricType) {
    CadenceMonitoringMetricType["DAILY_METRICS"] = "daily_metrics";
    CadenceMonitoringMetricType["CHAIN_METRICS"] = "chain_metrics";
    CadenceMonitoringMetricType["CHAIN_DETAILED_METRICS"] = "chain_detailed_metrics";
    CadenceMonitoringMetricType["CADENCE_PLATFORM_METRICS"] = "cadence_platform_metrics";
})(CadenceMonitoringMetricType || (CadenceMonitoringMetricType = {}));
